import styled from "styled-components";

export const Portait4Style = styled.div`
  .flex-column {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
  }

  .flex-row-center {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
  }

  .flex-row-left {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: left;
    justify-content: left;
  }

  .subflex-left {
    width: 100%;
    text-align: left;
  }

  .subflex-right {
    width: 100%;
    text-align: right;
  }

  .subflex-center {
    width: 100%;
    text-align: center;
  }
  .t4-mob-text-wrapper {
    white-space: pre-wrap;
  }
  /*.f-arial {*/
  /*	font-family: Arial;*/
  /*}*/

  /*.f-mvboli {*/
  /*	font-family: mvboli;*/
  /*}*/

  /*.f-nexalight {*/
  /*	font-family: nexalight;*/
  /*}*/

  /*.f-nexabold {*/
  /*	font-family: nexabold;*/
  /*}*/

  .f-cyan {
    color: #00fffc;
  }

  .f-cyan-dark {
    color: #00d1cf;
  }

  .f-blue {
    color: #005596;
  }

  .f-white {
    color: #ffffff;
  }

  .poster {
    position: relative;
    overflow: hidden !important;
  }

  .poster.nine-by-sixteen {
    width: 1080px;
    height: 1920px;
  }

  .poster.one-by-one {
    width: 310px;
    height: 310px;
  }

  .poster.nine-by-sixteen {
    width: 171px;
    height: 304px;
  }

  .poster.nine-by-sixteen .bg.four {
    position: absolute;
    height: 110%;
    width: 110%;
    top: -9%;
  }

  .poster.nine-by-sixteen .poster-content.four {
    position: absolute;
    bottom: 200px;
    right: 420px;
    width: 0;
    padding: 0;
    overflow: hidden;
  }

  .poster.nine-by-sixteen .poster-content.four .t4-mob-text-wrapper {
    //width: 706px;
    background-color: #005596;
    text-align: center;
    padding: 5px 0;
  }

  .poster.nine-by-sixteen .poster-content.four .ta {
    font-size: 45px;
    line-height: 60px;
    margin: 0;
  }

  .poster.nine-by-sixteen .poster-content.four .ta {
    font-size: 7px !important;
    line-height: 10px;
    padding: 0 !important;
    margin: 0 !important;
  }

  .poster.nine-by-sixteen .bg.four {
  }

  .poster.nine-by-sixteen .poster-content.four {
    bottom: 40px;
    right: 56px;
  }

  .poster-content {
    position: absolute;
    bottom:20%;
    width:90%;
    right:5%;
    height:35%;
  }


  .text-wrappers {
    position:absolute;
    width:100%;
    height:100%
  }
  .text-wrappers > div {
    width:100%;
    overflow: hidden;
  }
`;
